import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {UserLookupType} from '../../../../../../../util/uiconstants';
import {labels} from '../../../../../../../util/utils';
import {getUserWithProps} from './utils';

import UserSearch from '../../../../../../Common/Search/CustomizedUsersearch';
import StyledContactSelector from './StyledContactSelector';

const ContactSelector = ({id, value, onChange, onAdd, onAddDisabled, projectId}) => {
	const [clearSearchResult, setClearSearchResult] = useState(false);

	const renderSearch = () => {
		const handleUserClear = () => {
			onChange(null);
			setClearSearchResult(false);
		};

		const props = {
			lookupType: UserLookupType.NotSpecified,
			maxSearchLength: 50,
			doNotDispatchUserEmpty: true,
			canClearSelectedValue: true,
			clearUserData: clearSearchResult,
			onUserSelectionChange: (opt) => { 
				onAdd(getUserWithProps(opt));
				setClearSearchResult(true); 
			},
			onUserClear: handleUserClear,
			showIsRequired: false,
			projectId,
			includeEngDetails: true
		};

		return <UserSearch {...props} />;
	};

	return (
		<StyledContactSelector>
			{renderSearch()}
		</StyledContactSelector>
	);
};

ContactSelector.propTypes = {};

ContactSelector.defaultProps = {};

export default ContactSelector;
